import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import React from 'react';
import PropTypes from 'prop-types';
import { useTheme } from '@mui/styles';
import { ArrowLeftShort } from 'react-bootstrap-icons';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';

function BackButton(props) {
	const { t } = useTranslation();
	const navigate = useNavigate();
	const theme = useTheme();

	return (
		<Stack direction="row" spacing={2}>
			<Button
				variant="text"
				aria-label={t('back')}
				tabIndex={0}
				role="button"
				onClick={() => {
					navigate(-1);
				}}
				style={{
					color: theme.palette.primary.main,
					fontSize: theme.palette.textSize.sizeMd,
				}}
				startIcon={
					<ArrowLeftShort
						aria-hidden="true"
						aria-label={t('back')}
						role="graphics-symbol"
						style={{ marginRight: '-.25rem' }}
					/>
				}
			>
				{t(props.label || 'Back')}
			</Button>
		</Stack>
	);
}

BackButton.propTypes = {
	label: PropTypes.string,
};

export default BackButton;
